import React, { useEffect, useState } from 'react';
import './ConsolidatedStatementModal.css';
import { CrossButton, CustomSelect } from 'components';
import { getPaynowConsolidateApi } from '_services/accountingServices/accountingServices';
import { StreetViewService } from '@react-google-maps/api';
import StorageService from 'utils/StorageServices';

const MONTHS = [
  'January', 'February', 'March', 'April',
  'May', 'June', 'July', 'August',
  'September', 'October', 'November', 'December',
];

const currentYear = new Date().getFullYear();
const YEARS = Array.from({ length: 1 }, (_, i) => ({
  label: String(currentYear - i),
  value: currentYear - i,
}));

const ConsolidatedStatementModal = ({ closeModal, onDownload }) => {
  const [selectedYear, setSelectedYear] = useState({ label: String(currentYear), value: currentYear });
const [yearlist ,setYearList] = useState([])
  const [year, setYear] = useState(2026)
  const [statementList,setStatementList] = useState([])

  const handleDownload = (monthIndex) => {
    const month = String(monthIndex + 1).padStart(2, '0');
    onDownload?.({ year: selectedYear.value, month });
  };


  const getFetchHandle = async () => {
 console.log("payload")
    const payload = {
      firm_id: StorageService.getFirmId(),
      year: year
    }

    console.log(payload)

    try {
      const res = await getPaynowConsolidateApi({ firm_id:payload?.firm_id,year:payload?.year})
      if(res?.responseCode==200){
        setStatementList(res?.data?.statement_data)

        const resultList = res?.data?.years_list?.map((i)=>({label:toString(i),value:i}))

        setYearList(resultList)
      }

      console.log(res)
    } catch (error) {

    }

  }

  useEffect(() => {
    getFetchHandle()
  }, [])

  return (
    <div className="cs-overlay" >
      <div className="cs-modal" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="cs-header">
          <h2 className="cs-title">Consolidated Statement</h2>
          <CrossButton
            type="button"
            className="_switchBtn __animEffect_btn"
            style={{ marginLeft: "auto" }}
            onClick={closeModal}
          >
            <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path
                d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                fill="black" />
            </svg>
          </CrossButton>
        </div>

        {/* Body */}
        <div className="cs-body">

          {/* Year Dropdown */}
          <div className="cs-select-wrapper">
            {/* <select
              className="cs-year-select"
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
            >
              {YEARS.map((yr) => (
                <option key={yr} value={yr}>{yr}</option>
              ))}
            </select>
            <span className="cs-select-arrow">▼</span> */}
            <CustomSelect options={yearlist} value={selectedYear} onSelect={(data) => setSelectedYear(data)} />
          </div>

          {/* Month List */}
          <div className="cs-month-list">
            {MONTHS.map((month, idx) => (
              <div key={month} className="cs-month-row">
                <span className="cs-month-name">{month}</span>
                <button
                  className="cs-download-link"
                  onClick={() => handleDownload(idx)}
                >
                  Download PDF
                </button>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default ConsolidatedStatementModal;